import React, { useCallback, useEffect } from "react";
import { CameraView, Camera } from "expo-camera";
import { StyleSheet, Text, View } from "react-native";
import {
	SET_DROP_DOWN_ALERT_INFO,
	SET_HAS_CAMERA_PERMISSION,
	SET_SCANNED_DATA,
	CLEAR_SCAN,
	HIDE_QR_CODE_SCANNER_MODAL
} from "../actions/types";
import commonStyles, { DARKGREY_COLOR } from "../styles/commonStyles";
import Modal from "react-native-modalbox";
import { Button } from "react-native-elements";
import { SafeAreaView } from "react-native-safe-area-context";
import { t } from "../services/i18n";
import { useDispatch, useSelector } from "react-redux";
import { useFocusEffect } from "@react-navigation/core";

export default function QrCodeScannerModal() {
	const dispatch = useDispatch();
	const {
		scanned,
		hasCameraPermission,
		isUnknownDeepLink,
		showQrCodeScannerModal
	} = useSelector(state => state.urlscanReducer);

	useFocusEffect(
		useCallback(() => {
			// const onBackPress = () => {
			// 	if (showQrCodeScannerModal) {
			// 		dispatch({
			// 			type: HIDE_QR_CODE_SCANNER_MODAL
			// 		});
			// 		return true;
			// 	} else {
			// 		return false;
			// 	}
			// };

			if (showQrCodeScannerModal) {
				(async () => {
					// Check before requesting: on web the request opens (then stops) a
					// camera stream, which must not overlap the CameraView's own
					// stream. The check (navigator.permissions) opens none.
					let { status } = await Camera.getCameraPermissionsAsync();
					if (status !== "granted") {
						({ status } = await Camera.requestCameraPermissionsAsync());
					}
					dispatch({
						type: SET_HAS_CAMERA_PERMISSION,
						payload: status === "granted"
					});
					if (status !== "granted") {
						dispatch({
							type: SET_DROP_DOWN_ALERT_INFO,
							info: "camerainfo"
						});
					}
				})();
			}
		}, [showQrCodeScannerModal])
	);

	useEffect(() => {
		if (isUnknownDeepLink) {
			dispatch({
				type: SET_DROP_DOWN_ALERT_INFO,
				info: "unknownurlinfo"
			});
		}
	}, [isUnknownDeepLink]);

	const handleBarCodeScanned = scannedData => {
		dispatch({
			type: SET_SCANNED_DATA,
			payload: scannedData
		});
	};

	const {
		justifyContentCenter,
		alignItemsCenter,
		flex1,
		spaceBetween,
		w100p,
		fontBold,
		fs18,
		white,
		color2,
		mv20,
		red,
		bgBlack
	} = commonStyles;

	return (
		<Modal
			backdrop={true}
			backdropOpacity={0.7}
			backdropColor="black"
			position="center"
			style={StyleSheet.absoluteFillObject}
			backdropPressToClose={false}
			swipeToClose={false}
			isOpen={showQrCodeScannerModal}
		>
			{hasCameraPermission === null ? (
				<View />
			) : !hasCameraPermission ? (
				<View style={[flex1, alignItemsCenter, justifyContentCenter]}>
					<Text style={[fontBold, red, fs18]}>{t("login:nocameraaccess")}</Text>
				</View>
			) : (
				<CameraView
					barcodeScannerSettings={{ barcodeTypes: ["qr"] }}
					onBarcodeScanned={scanned ? undefined : handleBarCodeScanned}
					style={[StyleSheet.absoluteFillObject, bgBlack]}
				>
					<SafeAreaView style={[flex1, w100p, spaceBetween]}>
						<View
							style={[
								w100p,
								alignItemsCenter,
								justifyContentCenter,
								{ marginTop: 30 }
							]}
						>
							<Text style={[fontBold, white, fs18]}>
								{t("login:scanqrcode")}
							</Text>
						</View>

						<View style={[styles.container]}>
							<View style={[styles.finder, { width: 280, height: 280 }]}>
								<View
									style={[
										{ borderColor: DARKGREY_COLOR },
										styles.topLeftEdge,
										{
											borderLeftWidth: 3,
											borderTopWidth: 3
										}
									]}
								/>
								<View
									style={[
										{ borderColor: DARKGREY_COLOR },
										styles.topRightEdge,
										{
											borderRightWidth: 3,
											borderTopWidth: 3
										}
									]}
								/>
								<View
									style={[
										{ borderColor: DARKGREY_COLOR },
										styles.bottomLeftEdge,
										{
											borderLeftWidth: 3,
											borderBottomWidth: 3
										}
									]}
								/>
								<View
									style={[
										{ borderColor: DARKGREY_COLOR },
										styles.bottomRightEdge,
										{
											borderRightWidth: 3,
											borderBottomWidth: 3
										}
									]}
								/>
							</View>
						</View>
						<View style={[w100p, alignItemsCenter, justifyContentCenter, mv20]}>
							{isUnknownDeepLink ? (
								<Button
									type="clear"
									activeOpacity={0.8}
									title={t("button:rescan")}
									onPress={() =>
										dispatch({
											type: CLEAR_SCAN
										})
									}
									titleStyle={[color2, fontBold, fs18]}
								/>
							) : (
								<Button
									type="clear"
									activeOpacity={0.8}
									title={t("button:cancel")}
									onPress={() =>
										dispatch({
											type: HIDE_QR_CODE_SCANNER_MODAL
										})
									}
									titleStyle={[white, fontBold, fs18]}
								/>
							)}
						</View>
					</SafeAreaView>
				</CameraView>
			)}
		</Modal>
	);
}

const styles = StyleSheet.create({
	container: {
		alignItems: "center",
		justifyContent: "center",
		position: "absolute",
		// backgroundColor: "rgba(0,0,0,1.0)",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0
	},
	finder: {
		alignItems: "center",
		justifyContent: "center",
		backgroundColor: "rgba(255,255,255,0.1)"
	},
	topLeftEdge: {
		position: "absolute",
		top: 0,
		left: 0,
		width: 40,
		height: 20
	},
	topRightEdge: {
		position: "absolute",
		top: 0,
		right: 0,
		width: 40,
		height: 20
	},
	bottomLeftEdge: {
		position: "absolute",
		bottom: 0,
		left: 0,
		width: 40,
		height: 20
	},
	bottomRightEdge: {
		position: "absolute",
		bottom: 0,
		right: 0,
		width: 40,
		height: 20
	}
});
